import { render, staticRenderFns } from "./SaveReportWizardColumns.vue?vue&type=template&id=3231fb58"
import script from "./SaveReportWizardColumns.vue?vue&type=script&lang=js"
export * from "./SaveReportWizardColumns.vue?vue&type=script&lang=js"
import style0 from "./SaveReportWizardColumns.vue?vue&type=style&index=0&id=3231fb58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports